import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IReleaseActions, IReleaseStore, IThunkReadAllReleaseUpdates } from '../types';

const onReadReleaseUpdates: IThunkReadAllReleaseUpdates = thunk(
  async ({ setReleaseUpdates }: Actions<IReleaseActions>, payload, { getState }) => {
    const localState = getState() as IReleaseStore;
    await api.release.readAllReleaseUpdates(payload);

    setReleaseUpdates({ ...localState.releaseUpdates, updatesAvailable: false });
  },
);

export default onReadReleaseUpdates;
